import TimekeeperHeader from "../../components/timekeeperheader";
import React, {useEffect, useRef, useState} from "react";
import s from './styles.module.css'
import api from "../../api";
import ModalElement from "./modal/index.jsx";

const Timekeeper = ({headerData, stompClient, coachTypeId, coachTypeNumber}) => {
    const [entryTimer, setEntryTimer] = useState(0.0);
    const [deckTimer, setDeckTimer] = useState(0.0);
    const [routineTimer, setRoutineTimer] = useState(0.0);
    const [isEntryRunning, setIsEntryRunning] = useState(false);
    const [isDeckRunning, setIsDeckRunning] = useState(false);
    const [isRoutineRunning, setIsRoutineRunning] = useState(false);
    const [isEntryOut, setIsEntryOut] = useState(false);
    const [isDeckOut, setIsDeckOut] = useState(false);
    const [isRoutineOut, setIsRoutineOut] = useState(false);
    const [entryLimit, setEntryLimit] = useState(600.0);
    const [deckLimit, setDeckLimit] = useState(600.0);
    const [routineLimit, setRoutineLimit] = useState(600.0);
    const [pressCount, setPressCount] = useState(0);
    const [startTime, setStartTime] = useState(0.00);
    const [intervalId, setIntervalId] = useState(null);
    const [wasEntryStarted, setWasEntryStarted] = useState(false);
    const [wasDeckStarted, setWasDeckStarted] = useState(false);
    const [wasRoutineStarted, setWasRoutineStarted] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const elapsedTimeRef = useRef(0.0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log("Возрастная группа: ", headerData?.age_group_id)
                console.log("Дисциплина: ", headerData?.discipline_id)

                const response = await api().get(
                    `${process.env.REACT_APP_API_URL}/coach/timer-limits/${headerData?.age_group_id}/${headerData?.discipline_id}`
                );

                console.log(response)

                if (response?.data?.status === 'ok') {
                    setEntryLimit(response?.data?.entry_limit);
                    setDeckLimit(response?.data?.deck_limit);
                    setRoutineLimit(response?.data?.routine_limit);
                } else {
                    console.error('Failed to send results');
                }
            } catch (error) {
                console.error('Error sending results:', error);
            }
        };

        if (headerData?.age_group_id && headerData?.discipline_id) {
            fetchData().then();
        }

    }, [headerData]);

    function sendSocket() {
        if (stompClient && stompClient.connected) {
            const dataToSend = {
                competitionApplicationDisciplineId: headerData?.competition_application_discipline_id,
                entry: isEntryRunning ? elapsedTimeRef.current : entryTimer,
                deck: isDeckRunning ? elapsedTimeRef.current : deckTimer,
                routine: isRoutineRunning ? elapsedTimeRef.current : routineTimer,
                coachTypeId: coachTypeId,
                coachTypeNumber: coachTypeNumber,
                isEntryRunning: isEntryRunning,
                isDeckRunning: isDeckRunning,
                isRoutineRunning: isRoutineRunning,
                wasEntryStarted: wasEntryStarted,
                wasDeckStarted: wasDeckStarted,
                wasRoutineStarted: wasRoutineStarted,
                isEntryOut: isEntryOut,
                isDeckOut: isDeckOut,
                isRoutineOut: isRoutineOut
            };
            stompClient.send('/socket/update-timers', {}, JSON.stringify(dataToSend));
        }
    }

// Функция для обновления таймеров каждые 10 мс
    useEffect(() => {
        if (isEntryRunning || isDeckRunning || isRoutineRunning) {
            const id = setInterval(() => {
                const currentTime = performance.now() / 1000;
                elapsedTimeRef.current = Math.floor((currentTime - startTime) * 100) / 100;

                // Обновляем таймеры
                if (isEntryRunning) {
                    checkRules("entry", elapsedTimeRef.current);
                    setEntryTimer(elapsedTimeRef.current);
                }
                if (isDeckRunning) {
                    checkRules("deck", elapsedTimeRef.current);
                    setDeckTimer(elapsedTimeRef.current);
                }
                if (isRoutineRunning) {
                    checkRules("routine", elapsedTimeRef.current);
                    setRoutineTimer(elapsedTimeRef.current);
                }

                sendSocket();

            }, 10);

            setIntervalId(id);
            return () => clearInterval(id);
        } else {
            sendSocket();
        }
    }, [isEntryRunning, isDeckRunning, isRoutineRunning, startTime, isEntryOut, isDeckOut, isRoutineOut, stompClient]);

    const handleButtonPress = () => {
        setPressCount((prev) => prev + 1);
        console.log("Time: " + performance.now() / 1000);
        const currentTime = performance.now() / 1000;
        let type = 1

        if (pressCount === 0) { // 1-е нажатие: Старт Entry
            setStartTime(currentTime);
            setIsEntryRunning(true);
            setWasEntryStarted(true);
        } else if (pressCount === 1) { // 2-е нажатие: Стоп Entry
            if (isEntryRunning) {
                setIsEntryRunning(false);
                setEntryTimer(elapsedTimeRef.current);
                type = 2;
            }
        } else if (pressCount === 2) { // 3-е нажатие: Старт Deck и Routine
            setStartTime(currentTime);
            setIsDeckRunning(true);
            setIsRoutineRunning(true);
            setWasDeckStarted(true);
            setWasRoutineStarted(true);
            type = 3;
        } else if (pressCount === 3) { // 4-е нажатие: Стоп Deck
            if (isDeckRunning) {
                setIsDeckRunning(false);
                setDeckTimer(elapsedTimeRef.current);
                type = 4;
            }
        } else if (pressCount === 4) { // 5-е нажатие: Стоп Routine
            if (isRoutineRunning) {
                setIsRoutineRunning(false);
                setRoutineTimer(elapsedTimeRef.current);
                type = 5;
            }
        }

        sendResultsToBackend(type).then(() => {
            console.log("Send result type: " + type);
        });
    };

    const checkRules = (type, time) => {
        if (type === "entry" && time > entryLimit) {
            setIsEntryOut(true);
        }
        if (type === "deck" && time > deckLimit) {
            setIsDeckOut(true);
        }
        if (type === "routine" && (time < (routineLimit - 5.0) || time > (routineLimit + 5.0))) {
            setIsRoutineOut(true);
        } else {
            setIsRoutineOut(false);
        }
    };

    const sendResultsToBackend = async (type) => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

        const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
        let time;
        let is_limit;
        switch (type) {
            case 1:
            case 2: {
                time = isEntryRunning ? elapsedTimeRef.current : entryTimer;
                is_limit = isEntryOut;
                break
            }

            case 3: {
                time = isDeckRunning ? elapsedTimeRef.current : deckTimer;
                is_limit = isDeckOut;
                break;
            }

            case 4: {
                time = isDeckRunning ? elapsedTimeRef.current : deckTimer;
                is_limit = isDeckOut;
                break;
            }

            case 5: {
                time = isRoutineRunning ? elapsedTimeRef.current : routineTimer;
                is_limit = isRoutineOut;
                break;
            }

        }

        let timeFormat = formatTime(time);
        const results = {
            competition_application_discipline_id: headerData?.competition_application_discipline_id,
            timekeeper_value_type_id: type,
            timekeeper_value: timeFormat,
            is_limit: is_limit,
            stamp_create: formattedDateTime,
            coach_type_number: coachTypeNumber
        };
        try {
            const response = await api().post(`${process.env.REACT_APP_API_URL}/coach/timer-results`, results);
            console.log(response)
            if (response?.data?.status === 'ok') {
                console.log('Results sent to backend successfully');
            } else {
                console.error('Failed to send results');
            }
        } catch (error) {
            console.error('Error sending results:', error);
        }
    };

    const resetTimers = async () => {
        setEntryTimer(0.0);
        setDeckTimer(0.0);
        setRoutineTimer(0.0);
        setIsEntryRunning(false);
        setIsDeckRunning(false);
        setIsRoutineRunning(false);
        setWasEntryStarted(false);
        setWasDeckStarted(false);
        setWasRoutineStarted(false);
        setIsEntryOut(false);
        setIsDeckOut(false);
        setIsRoutineOut(false);
        setPressCount(0);
        setStartTime(0.00);
        elapsedTimeRef.current = 0.0;
        console.log(intervalId)
        if (intervalId) clearInterval(Number(intervalId));

        if (stompClient && stompClient.connected) {
            const dataToSend = {
                competitionApplicationDisciplineId: headerData?.competitionApplicationDisciplineId,
                entry: 0.0,
                deck: 0.0,
                routine: 0.0,
                coachTypeId: coachTypeId,
                coachTypeNumber: coachTypeNumber,
                isEntryRunning: false,
                isDeckRunning: false,
                isRoutineRunning: false,
                wasEntryStarted: false,
                wasDeckStarted: false,
                wasRoutineStarted: false,
                isEntryOut: false,
                isDeckOut: false,
                isRoutineOut: false,
            };
            stompClient.send('/socket/update-timers', {}, JSON.stringify(dataToSend));
        }
        try {
            let comAppDisId = headerData?.competition_application_discipline_id;
            const response = await api().get(`${process.env.REACT_APP_API_URL}/coach/timer-clear/${comAppDisId}/${coachTypeNumber}`);
            console.log(response)
            if (response?.data?.status === 'ok') {
                console.log('Results sent to backend successfully');
            } else {
                console.error('Failed to send results');
            }
        } catch (error) {
            console.error('Error sending results:', error);
        }
    };

    const formatTime = (time) => {
        const totalSeconds = Math.floor(time);
        const hundredths = Math.round((time % 1) * 100);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${hundredths.toString().padStart(2, '0')}`;
    };

    const getTimerBackground = (isRunning, wasStarted, isOut) => {
        return isOut ? "#E9695E" : isRunning ? "#ebc810" : wasStarted ? '#86b760' : '#ffffff';
    };

    const getTimerColor = (isRunning, wasStarted) => {
        return isRunning ? "#494747" : wasStarted ? '#494747' : '#494747';
    };

    return (
        <div>
            <TimekeeperHeader headerData={headerData} resetTimers={resetTimers} setIsOpenModal={setIsOpenModal}/>
            <div className={s.container}>
                <div className={s.timer_block}>
                    <div className={s.timer}>
                        <h2>Entry</h2>
                        <div className={s.timer_text} style={{
                            backgroundColor: getTimerBackground(isEntryRunning, wasEntryStarted, isEntryOut),
                            color: getTimerColor(isEntryRunning, wasEntryStarted)
                        }}>
                            <p>{formatTime(entryTimer)}</p>
                        </div>
                    </div>

                    <div className={s.timer}>
                        <h2>Deck</h2>
                        <div className={s.timer_text} style={{
                            backgroundColor: getTimerBackground(isDeckRunning, wasDeckStarted, isDeckOut),
                            color: getTimerColor(isDeckRunning, wasDeckStarted)
                        }}>
                            <p>{formatTime(deckTimer)}</p>
                        </div>
                    </div>

                    <div className={s.timer}>
                        <h2>Routine</h2>
                        <div className={s.timer_text} style={{
                            backgroundColor: getTimerBackground(isRoutineRunning, wasRoutineStarted, isRoutineOut),
                            color: getTimerColor(isRoutineRunning, wasRoutineStarted)
                        }}>
                            <p>{formatTime(routineTimer)}</p>
                        </div>
                    </div>
                </div>
                <button onClick={handleButtonPress} className={s.button}>
                    {(isEntryRunning || isDeckRunning || isRoutineRunning) ? "STOP" : "START"}
                </button>
            </div>
            {isOpenModal &&
                <ModalElement
                    isOpenModal={isOpenModal}
                    setIsOpenModal={setIsOpenModal}
                    onClose={() => setIsOpenModal(false)}
                    resetTimers={resetTimers}
                />}
        </div>
    );
};

export default Timekeeper;